import { Tooltip } from 'antd'
import classNames from 'classnames'
import React, { useRef } from 'react'
import './index.less'

function Bubble(props) {
  const { overlayClassName, className, style, content, refStyle = {}, ...otherProps } = props
  const $content = useRef()

  return <Tooltip
    overlayClassName={classNames('mn-bubble', overlayClassName)}
    autoAdjustOverflow
    title={<div onClick={e => e.stopPropagation()} style={{ ...style }}>
      {content}
    </div>}
    {...otherProps}
  >
    <span className="bubble-child" ref={$content} style={refStyle}>{props.children}</span>
  </Tooltip>
}

Bubble.Dropdown = (props) => {
  return <Bubble
    overlayClassName="meinian-bubble-dropdown"
    placement="bottom"
    {...props}
  />
}

export default Bubble
